"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var colors = {
  aliceBlue: '#e9f5fb',
  antiFlashWhite: '#f3f3f3',
  chalice: '#aaaaaa',
  error: '#b00020',
  errorHover: '#9c001c',
  primaryHover: '#228cbd',
  quartz: '#4a4a4a',
  secondary: '#1ca800',
  secondaryHover: '#199700',
  silverSand: '#c2c2c2',
  vibrentBlue: '#269cd2',
  white: '#ffffff',
  columbiaBlue: '#cbd8e5'
};
var _default = colors;
exports.default = _default;